import React from 'react';

import PropTypes from 'prop-types';

import TrackerCard from './trackerCard';

const VideoTelematics = ({ hardwareList, tracker }) => {
  const {
    videoTelematicsTracker,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: 'Video Telematics',
    hardwareList,
    rateplanTotal: videoTelematicsTracker,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

VideoTelematics.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    videoTelematicsTracker: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default VideoTelematics;
